import { httpClient } from '../httpClient';
import {
  IProjectSetting,
  ProjectSettingType,
  UpdateProjectSettingRequest
} from '@packages/global';

/**
 * 项目设定 API 模块
 * 处理世界观、写作风格、故事梗概等设定
 */
export class ProjectSettingApi {

  /**
   * 获取项目所有设定
   */
  async getSettings(projectId: string): Promise<IProjectSetting[]> {
    return httpClient.get<IProjectSetting[]>(`/user/projects/${projectId}/settings`);
  }

  /**
   * 创建或更新设定
   */
  async updateSetting(
    projectId: string,
    settingType: ProjectSettingType,
    data: UpdateProjectSettingRequest
  ): Promise<IProjectSetting> {
    return httpClient.put<IProjectSetting>(`/user/projects/${projectId}/settings/${settingType}`, data);
  }

  /**
   * 删除设定
   */
  async deleteSetting(projectId: string, settingType: ProjectSettingType): Promise<void> {
    return httpClient.delete<void>(`/user/projects/${projectId}/settings/${settingType}`);
  }
}

// 导出单例实例
export const projectSettingApi = new ProjectSettingApi();
